enum AvailabilityIndex {
    NOT_AVAILABLE='NOT_AVAILABLE', CANNOT_BE_DETERMINED='CANNOT_BE_DETERMINED', SOLD_OUT = "SOLD_OUT", LOW = "LOW", MODERATE = "MODERATE", HIGH = "HIGH"
}

export default AvailabilityIndex;